import React, {useEffect} from 'react';
import PropTypes from "prop-types";
import {useSelector, useDispatch} from "react-redux";
import {closeDrawer} from "../../actions/drawerActions";
import QuestionnaireReviewHook from "../qd/questionnaires/QuestionnaireReviewHook";
import CategoryReviewHook from "../qd/categories/CategoryReviewHook";
import GroupReviewHook from "../qd/groups/GroupReviewHook";
import QuestionReviewHook from "../qd/questions/QuestionReviewHook";
import ArgoAppBarHook from "../common/ArgoAppBarHook";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import * as TEMPLATE from "../../constants/templateConstants";

const ReviewDrawer = ({templateId, templateKey, templateType}) => {
    const dispatch = useDispatch();
    const drawerStack = useSelector(state => state.drawerStack)

    const handleCloseDrawer = () => {
        dispatch(closeDrawer());
    };

    const handleClickAway = (event) => {
        // Checks is target is BODY first because portal preview DDLBs cause target to be body and we shouldn't close on that
        if (event.target.tagName !== 'BODY') {
            handleCloseDrawer();
        }
    };

    const getReviewComponent = () => {
        switch(templateType) {
            case TEMPLATE.TYPE.QUESTIONNAIRE:
                return <QuestionnaireReviewHook
                    templateId={templateId}
                    templateKey={templateKey}
                    width={reviewDrawerProps.width}
                />
            case TEMPLATE.TYPE.CATEGORY:
                return <CategoryReviewHook
                    templateId={templateId}
                    templateKey={templateKey}
                    width={reviewDrawerProps.width}
                />
            case TEMPLATE.TYPE.GROUP:
                return <GroupReviewHook
                    templateId={templateId}
                    templateKey={templateKey}
                    width={reviewDrawerProps.width}
                />
            case TEMPLATE.TYPE.QUESTION:
                return <QuestionReviewHook
                    templateId={templateId}
                    templateKey={templateKey}
                    width={reviewDrawerProps.width}
                />
            // no default
        }
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                e.preventDefault()
                handleCloseDrawer()
            }
        }

        document.addEventListener("keydown", handleKeyDown, true)

        return () => {document.removeEventListener("keydown", handleKeyDown, true)}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <div style={{height: "100%"}}>
                <ArgoAppBarHook
                    title={drawerStack.displayTitle}
                    showMenuArrowButton="LEFT"
                    onLeftIconButtonTouchTap={handleCloseDrawer}
                    isDrawer={true}
                    width={reviewDrawerProps.width}
                />

                <div style={{height: '64px'}}></div>

                {getReviewComponent()}
            </div>
        </ClickAwayListener>
    );
};

ReviewDrawer.propTypes = {
    templateId: PropTypes.number
};

const reviewDrawerProps = {
    opensecondary: true,
    width: "90%",
    docked: false,
    anchor: "right"
};

export default ReviewDrawer;
export {reviewDrawerProps};
